import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const ThingsToDo = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddThingsToDo = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditThingsToDo = () => {
  return (
    
      
        <Edit />
      
    
  );
};
